var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOdp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 4,
    x2: 28,
    y1: 31,
    y2: 1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d0120d",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fe9c45",
    offset: 1
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "file_type_libreoffice_impress") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.875 0 0 .875 2 2)",
    fillRule: "evenodd",
    strokeLinecap: "square"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m7 0c-2.216 0-4 1.784-4 4v24c0 2.216 1.784 4 4 4h18c2.216 0 4-1.784 4-4v-16l-12-12zm13 0 9 9v-9z",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3 27v1c0 2.216 1.784 4 4 4h18c2.216 0 4-1.784 4-4v-1c0 2.216-1.784 4-4 4h-18c-2.216 0-4-1.784-4-4z",
    fillOpacity: 0.19862
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20 0h1.4l7.6 7.6v1.4z",
    fillOpacity: 0.20149
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fafafa"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 13,
    width: 16,
    height: 1,
    ry: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 15,
    width: 12,
    height: 1,
    ry: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 19.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 21.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 23.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 19,
    width: 5,
    height: 1,
    ry: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 21,
    width: 5,
    height: 1,
    ry: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 23,
    width: 5,
    height: 1,
    ry: 0.5
  })), /*#__PURE__*/React.createElement("path", {
    d: "m17 19c-0.554 0-1 0.446-1 1v4c0 0.554 0.446 1 1 1h6c0.554 0 1-0.446 1-1v-4c0-0.554-0.446-1-1-1zm5.4219 1.0059a0.5 0.5 0 0 1 0.43164 0.14062 0.5 0.5 0 0 1 0 0.70703l-2.3535 2.3535-1-1-1.6465 1.6465a0.5 0.5 0 0 1-0.70703 0 0.5 0.5 0 0 1 0-0.70703l2.3535-2.3535 1 1 1.6465-1.6465a0.5 0.5 0 0 1 0.27539-0.14062z",
    fill: "#fecfb5"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOdp);
export default __webpack_public_path__ + "static/media/odp.6d5675cb300bde9ce3239d55c134c788.svg";
export { ForwardRef as ReactComponent };